<template>
	<BaseCard
		v-if="!isLoading"
		:title="$t('appraisal_calculation').toString()"
		@clickEdit="$router.push({ name: 'damagecases.repairapproval', params: { id: $route.params.processId } })"
		:is-editable="true"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<template #icons>
			<div class="flex items-center">
				<font-awesome-icon icon="exclamation-triangle" v-if="missingFinalCalculation" class="text-red-700" />
			</div>
		</template>
		<div v-if="process.damageAssessor">
			<BaseCardRow :value="getDocumentUploaded('vorläufige-kalkulation').toString()" :label="$t('calculation_advance_pdf_uploaded')" />
			<BaseCardRow :value="getDocumentUploaded('vorläufige-kalkulation (dat3 zip)').toString()" :label="$t('calculation_advance_zip_uploaded')" />
			<BaseCardRow class="mt-6" :value="getDocumentUploaded('finale-kalkulation').toString()" :label="$t('calculation_final_pdf_uploaded')" />
			<BaseCardRow :value="getDocumentUploaded('finale-kalkulation (dat3 zip)').toString()" :label="$t('calculation_final_zip_uploaded')" />
			<BaseCardRow class="mt-6" :value="getDocumentUploaded('gutachten').toString()" :label="$t('expertise_pdf_uploaded')" />
		</div>
		<div v-else class="font-bold">
			{{ $t('please_assign_damage_assessor') }}
		</div>
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow.vue';
import { getStringFromDate, getTimeFromDate } from '@/plugins/Utils';

export default {
	name: 'ProcessApprovalCard',
	components: { BaseCardRow, BaseCard },
	props: {
		process: { required: true },
		isToggleOpen: { type: Boolean, default: true },
	},
	computed: {
		missingFinalCalculation() {
			if (this.process.damageAssessor) {
				let finalCalculation = false;
				const damageAssessorDocs = this.$store.getters.getDocumentsDamageAssessor;
				if (damageAssessorDocs === undefined || damageAssessorDocs.length < 0) {
					finalCalculation = true;
				} else {
					const doc = damageAssessorDocs.find(document => document.type === 'gutachten');
					return doc.uuid == null;
				}
				return finalCalculation;
			} else {
				return true;
			}
		},
	},
	data() {
		return {
			documents: null,
			isLoading: true,
		};
	},
	methods: {
		getDocumentUploaded(type) {
			return this.$store.getters.getDocumentsDamageAssessor.find(doc => doc.type === type).uuid == null
				? this.$t('general.no').toLowerCase()
				: getStringFromDate(new Date(this.$store.getters.getDocumentsDamageAssessor.find(doc => doc.type === type).created_at * 1000)) +
						' (' +
						getTimeFromDate(new Date(this.$store.getters.getDocumentsDamageAssessor.find(doc => doc.type === type).created_at * 1000)) +
						' Uhr)';
		},
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
	},
	watch: {
		'$store.getters.getDocumentsDamageAssessor': function(value) {
			if (value !== undefined) {
				this.isLoading = false;
			}
		},
	},
};
</script>
